export default __webpack_public_path__ + "static/media/Exaltate's Tasset.37e20b7b.jpg";